// Generated by purs version 0.14.5
"use strict";
var callCC = function (dict) {
    return dict.callCC;
};
module.exports = {
    callCC: callCC
};
